<template>
    <div>
        <div id="mainhold">
            <div class="searchBox">
                <input type="text" class="blankbox" v-model="searchKey" @change="queryIT">
            </div>
            <div class="userFound" v-if="didQuery">
                <div class="profilepic" :style="{ 'background-image': `url(${user.userphoto})`}"></div>
                <div class="wrap amTealregular cpointer" @click="viewProfile(user.username)">{{user.username}} | {{user.firstname}} {{user.lastname}}</div>
                <div class="wrap amMintrregular">{{userInfo.email}} | {{userInfo.user_Id}}</div>
                <div class="wrap amTealregular">{{userInfo.phone}}</div>
                <div class="wrap amGrayregular">{{user.signedUpOn}} | member since {{user.joined}} </div>
                <div class="spacer"></div>
                <div class="wrap amTealregular">Personal Information</div>
                <div class="wrap amGrayregular">Legal Name: {{userInfo.fullname}}</div>
                <div class="wrap amGrayregular">Birth Date: {{userInfo.birthdate}}</div>
                <div class="wrap amGrayregular">Location: {{userInfo.profile_city}}, {{userInfo.profile_state}}, {{userInfo.profile_country}}</div>
                <div class="wrap amTeallight">Sender Address: {{userInfo.s_address}} || {{userInfo.stripeId}}</div>
                <div class="spacer"></div>
                <div class="wrap amTealregular">Permissions & Verifications</div>
                <div class="wrap amGrayregular">Identity Verification Status: {{}}</div>
                <div class="wrap amGrayregular">Seller Status: {{}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import db from '../main'
import moment from 'moment'
export default {
    name: 'usertool',
    data(){
        return {
            searchKey: "",
            userInfo: {},
            user: {},
            stats: {},
            userID: "",
            didQuery: false
        }
    },
    methods: {
        queryIT(){
            this.didQuery = true
            if(this.searchKey !== ""){
                this.user = {}
                this.userInfo = {}
                console.log(this.searchKey)
                const key = this.searchKey
                const username = this.searchKey.toLowerCase()
                db.collection('users').where('username', '==', username).get().then(usernamedoc => {
                    if(!usernamedoc.empty){
                        usernamedoc.forEach(doc => {
                            const data = doc.data();
                            const unixDate = data.dateJoined.seconds * 1000
                            data.joined = moment(unixDate).format('LL');
                            this.user = data;
                            this.userID = data.user_Id;
                            this.usageInfo();
                        })
                    } else {
                        db.collection('users').doc(key).get().then(userdoc => {
                    if(userdoc){
                        const data = userdoc.data();
                        const unixDate = data.dateJoined.seconds * 1000
                        data.joined = moment(unixDate).format('LL');
                        this.user = data;
                        this.userID = data.user_Id;
                        this.usageInfo();
                    }
                })
                    }
                })
                // db.collection('users').doc(key).get().then(userdoc => {
                //     if(userdoc){
                //         const data = userdoc.data();
                //         this.user = data;
                //     }
                // })
                db.collection('userinfo').where('username', '==', username).get().then(usernamedoc => {
                    if(!usernamedoc.empty){
                        usernamedoc.forEach(doc => {
                            const data = doc.data();
                            this.userInfo = data;
                            console.log(data)
                        })
                    } else {
                         db.collection('userinfo').doc(key).get().then(userdoc => {
                    if(userdoc){
                        const data = userdoc.data();
                        this.userInfo = data;
                        console.log('userinfo 2', data)
                    }
                })
                    }
                })
            
        }
    },
    usageInfo(){
        
    },
    viewProfile(username){
        const profileLink = "https://artmuseo.com/profile/?user=" + username
        console.log(profileLink, username)
        window.open(profileLink, "_blank");
    },
    }
}
</script>

<style scoped>
#mainhold {
    width: 100vw;
    height: 100vh;
    background-color: whitesmoke;
    position: absolute;
    z-index: 100;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: both;
}

.searchBox {
    width: 400px;
    height: 100px;
    margin-top: 100px;
    margin-left: 100px;
    top: 0;
    left: 0;
    position: fixed;
    background-color: #a9d9c3;
    border-radius: 1vmin;
}

.userFound {
    width: 80%;
    margin-left: 20%;
    height: auto;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 100px;
}

.blankbox {
    width: 100%;
    padding: 20px 0;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: 1.5em;
    text-align: center;
    color: white;
    background-color: #a9d9c3;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}
.profilepic {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    margin-top: 20px;
    margin-bottom: 20px;
    border-style: solid;
    border-color: #00a89d;
    margin-left: auto;
    margin-right: auto;
    background-size: contain;
    background-position: center;
}
</style>